export enum CustomRequestStatus {
  UNDER_REVIEW = "under_review",
  APPLICANTS_SENT = "applicants_sent",
  RESOLVED = "resolved"
};

export const customRequestStatusNames: {[key in CustomRequestStatus]: string } = {
  [CustomRequestStatus.UNDER_REVIEW]: "Under review",
  [CustomRequestStatus.APPLICANTS_SENT]: "Applicants sent",
  [CustomRequestStatus.RESOLVED]: "Resolved",
};